import React from 'react'
import ReactDOM from 'react-dom'
import { ReactComponent as IconCross } from '../../assets/svg/cross.svg'

export interface SideModalInterface {
  isOpen: ConstrainBoolean
  toggle: () => void
  title: string
  children: React.ReactNode
  overlay?: boolean
}

const SideModal = ({ isOpen, title, children, toggle, overlay = true }: SideModalInterface) => {
  const portalDiv = document.getElementById('modal')
  const modal = (
    <>
      <div
        className={`fixed left-0 top-0 z-50 flex h-screen w-screen justify-end ${
          overlay && 'bg-black bg-opacity-60'
        }`}
      >
        <div
          style={{ boxShadow: '-13px 0px 30px -10px rgba(0,0,0,0.1)' }}
          className="z-50 h-full min-h-screen w-full max-w-full overflow-y-scroll bg-white md:max-w-[500px]"
        >
          <div className="flex flex-row items-center justify-between border-b border-gray-300 px-6 py-4">
            <h3>{title}</h3>
            <div onClick={toggle} className="cursor-pointer">
              <IconCross />
            </div>
          </div>
          {children}
        </div>
      </div>
    </>
  )
  if (isOpen) {
    return portalDiv ? ReactDOM.createPortal(modal, portalDiv) : null
  } else {
    return null
  }
}

export default SideModal
